import { LockClosedIcon } from '@radix-ui/react-icons';
import { Box, Card, Grid, Heading, Text } from '@workos-inc/design-system';
import Head from 'next/head';
import NextLink from 'next/link';
import { Header } from 'src/components/header';
import { NavigationWrapper } from 'src/components/navigation-wrapper';
import { PageBackground } from 'src/components/page-background';
import { PageLayout } from 'src/components/page-layout';
import { Subtitle } from 'src/components/subtitle';
import { createPageDescription, createPageTitle } from 'src/utils/create-page-metadata';
const title = createPageTitle('Tools');
const description = createPageDescription('Developer tools for debugging and inspecting authentication tokens, credentials, and more.');
const toolItems = [{
  title: 'JWT Debugger',
  description: 'Decode, inspect, and verify JSON Web Tokens. Supports HMAC-SHA256 signature verification.',
  icon: LockClosedIcon,
  url: '/tools/jwt-debugger'
}];
const ToolsPage = () => <Box position="relative" data-sentry-element="Box" data-sentry-component="ToolsPage" data-sentry-source-file="index.tsx">
    <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
      <title>{title}</title>
      <meta content={description} name="description" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
      <meta content={description} name="og:description" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
      <meta content={title} property="og:title" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
      <meta content="website" property="og:type" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
    </Head>

    <PageBackground data-sentry-element="PageBackground" data-sentry-source-file="index.tsx" />

    <Header caption="Tools" data-sentry-element="Header" data-sentry-source-file="index.tsx" />

    <PageLayout.Root layout="index" data-sentry-element="PageLayout.Root" data-sentry-source-file="index.tsx">
      <PageLayout.Nav data-sentry-element="PageLayout.Nav" data-sentry-source-file="index.tsx">
        <NavigationWrapper data-sentry-element="NavigationWrapper" data-sentry-source-file="index.tsx" />
      </PageLayout.Nav>

      <PageLayout.Content data-algolia-exclude data-sentry-element="PageLayout.Content" data-sentry-source-file="index.tsx">
        <Heading as="h1" mb="2" size={{
        initial: '7',
        sm: '8'
      }} data-sentry-element="Heading" data-sentry-source-file="index.tsx">
          Tools
        </Heading>
        <Subtitle mb="7" data-sentry-element="Subtitle" data-sentry-source-file="index.tsx">
          Developer utilities for debugging and inspecting your integration.
        </Subtitle>

        <Grid columns={{
        initial: '1',
        sm: '2',
        md: '3'
      }} gap={{
        initial: '3',
        sm: '5'
      }} data-sentry-element="Grid" data-sentry-source-file="index.tsx">
          {toolItems.map(({
          icon: Icon,
          ...item
        }) => <Card key={item.url} asChild size="3" variant="classic">
              <NextLink href={item.url}>
                <Box mb="4">
                  <Icon height="32" width="32" />
                </Box>
                <Heading as="h2" mb="1" size="4">
                  {item.title}
                </Heading>
                <Text as="p" size="3">
                  {item.description}
                </Text>
              </NextLink>
            </Card>)}
        </Grid>
      </PageLayout.Content>
    </PageLayout.Root>
  </Box>;
export default ToolsPage;